import {Store} from "vuex";
// @ts-ignore
import {NavigationOpenRequestType,NavigationOpenRequestTypeFromMetaMenu,NavigationOpenRequestTypeFromShoppingcartMenu} from "owayo_menu";
import {UserModuleNames} from "@km/components/user/UserModulesAnimations";
import {EnumDictionary} from "@k/js/delme_globals";
import {LinksToWebsite} from "@k/js/databaseInterfaceClasses";
import {HTMLPrinter} from "@k/global/htmlprinter";
import {getGetParameterString} from "@k/global/axiosFormWrapper";

const naviMeta_openRequestActionMap = {
    [NavigationOpenRequestTypeFromMetaMenu.musterservice]:(store)=>window.open(store.getters["ModelStore/getLinkToWebsite"](LinksToWebsite.musterservice), "_blank"),
    [NavigationOpenRequestTypeFromMetaMenu.angebotsservice]:(store)=>window.open(store.getters["ModelStore/getLinkToWebsite"](LinksToWebsite.angebotsService), "_blank"),
    [NavigationOpenRequestTypeFromMetaMenu.designcheck]:(store)=>{store.commit("SET_OVERLAY_OPEN", 'designcheck')},
    [NavigationOpenRequestTypeFromMetaMenu.designwish]:(store)=>store.commit("SET_OVERLAY_OPEN", 'designwish'),
    [NavigationOpenRequestTypeFromMetaMenu.productsize]:(store)=>store.commit("SET_OVERLAY_OPEN", 'productsize'),
    [NavigationOpenRequestTypeFromMetaMenu.deliverytime]:(store)=>store.commit("SET_OVERLAY_OPEN", 'deliverytime'),
    [NavigationOpenRequestTypeFromMetaMenu.contact]:(store)=>store.commit("SET_OVERLAY_OPEN", 'contact'),
    [NavigationOpenRequestTypeFromMetaMenu.contactform]:(store)=>store.commit("SET_OVERLAY_OPEN", 'contactform'),
} as EnumDictionary<NavigationOpenRequestTypeFromMetaMenu, (store:Store<any>) => void>

function getShoppingcartURLParameters(store:Store<any>) {
    return HTMLPrinter.getURLParamString({land:store.getters["ModelStore/getLand"], language:store.getters["ModelStore/getLanguage"]})
}

function getWarenkorbReturnURL(params:{entwurfID, sprache, land, kundenKonfi, webSportFuerProduktAuswahlInt}) {
    const getParameters = getGetParameterString(
        {
            saveId:params.entwurfID,
            lang:params.sprache,
            land:params.land,
            returnLink:"true",
            sport:params.webSportFuerProduktAuswahlInt
        }
    );
    let returnURL = window.location.href.split('#')[0].split("?")[0] +"?"+getParameters
    if (params.kundenKonfi !== ""){
        returnURL = returnURL+"&konfi="+params.kundenKonfi;
    }
    return returnURL;
}

function setReturnURLInCookie(params:{entwurfID, sprache, land, kundenKonfi, webSportFuerProduktAuswahlInt}) {
    document.cookie = "Shoppingcart_ReturnURL=" + getWarenkorbReturnURL(params) + ";path=/";
}


export const naviShoppingcart_openRequestActionMap = {
    [NavigationOpenRequestTypeFromShoppingcartMenu.login]:(store)=>store.commit("OPEN_USERLAYER", UserModuleNames.login),
    [NavigationOpenRequestTypeFromShoppingcartMenu.logout]:(store)=>store.dispatch("logout"),
    [NavigationOpenRequestTypeFromShoppingcartMenu.orders]:(store)=>store.commit("OPEN_USERLAYER", UserModuleNames.orders),
    [NavigationOpenRequestTypeFromShoppingcartMenu.account]:(store)=>store.commit("OPEN_USERLAYER", UserModuleNames.account),
    [NavigationOpenRequestTypeFromShoppingcartMenu.shoppingcart]:(store)=>{
        setReturnURLInCookie({
            entwurfID:-1,
            land:store.getters["ModelStore/getLand"],
            sprache:store.getters["ModelStore/getSprache"],
            kundenKonfi:null,
            webSportFuerProduktAuswahlInt:store.getters["ModelStore/getWebSportFuerProduktAuswahlInt"]
        });
        window.location.href="/shoppingcart/index.php"+getShoppingcartURLParameters(store)
    },
} as EnumDictionary<NavigationOpenRequestTypeFromShoppingcartMenu, (store: Store<any>) => void>

export const naviComplete_openRequestActionMap = {...naviMeta_openRequestActionMap, ...naviShoppingcart_openRequestActionMap} as
    EnumDictionary<NavigationOpenRequestType, (store: Store<any>) => void>


export class Navigation_opencomponentHandler {
    private static store: Store<any>;
    private static requestTypeToActionMap:EnumDictionary<NavigationOpenRequestType, (store:Store<any>) => void>|EnumDictionary<NavigationOpenRequestTypeFromShoppingcartMenu, (store:Store<any>) => void>


    public static init(store:Store<any>, actionMap:EnumDictionary<NavigationOpenRequestType, (store:Store<any>) => void>|EnumDictionary<NavigationOpenRequestTypeFromShoppingcartMenu, (store:Store<any>) => void>) {
        Navigation_opencomponentHandler.store = store;
        Navigation_opencomponentHandler.requestTypeToActionMap = actionMap;
    }

    public static open_component(component:NavigationOpenRequestType|NavigationOpenRequestTypeFromShoppingcartMenu) {
        Navigation_opencomponentHandler.requestTypeToActionMap[component](Navigation_opencomponentHandler.store)
    }
}
